import * as angular from 'angular';
import * as _ from 'lodash';

import { ObjectType } from '../../models/enum';
import { IValueViewModel } from '../../models/viewModels/valueViewModel';
import { IRequestService } from '../request.service';

export interface IIdentifierVmService {
    getViewModelFromApi(guid: string, objectType: ObjectType): angular.IPromise<IValueViewModel>;
    getViewModelsFromApi(map: { guid: string; objectType: number }[]): angular.IPromise<IValueViewModel[]>;
    getViewModelsFromApiFromGuidList(guidList: string[]): angular.IPromise<IValueViewModel[]>;
    cleanCache(data: string[]);
    cleanCompleteCache(): void;
    getAllViewModels(): angular.IPromise<IValueViewModel[]>;
    getAllViewModels(force: boolean): angular.IPromise<IValueViewModel[]>;
    getSomeViewModels(guidList: string[]): angular.IPromise<IValueViewModel[]>;
}

export class IdentifierVmService implements IIdentifierVmService {
    static serviceId = 'identifierVmService';
    static $inject = ['requestService'];

    constructor(private requestService: IRequestService) {

    }

    getViewModelFromApi(guid: string, objectType: ObjectType): angular.IPromise<IValueViewModel> {
        return this.requestService.getAtV1('viewModel', {
            guid: guid,
            objectType: objectType
        }, true);
    }

    getAllViewModels(force: boolean = false): angular.IPromise<IValueViewModel[]> {
        const url = 'viewModel/all';
        if (force) {
            this.requestService.cleanCacheAtV1(url);
        }
        return this.requestService.getAtV1(url, undefined, true);
    }

    getSomeViewModels(guidList: string[]): angular.IPromise<IValueViewModel[]> {
        return this.getAllViewModels()
            .then(data => {
                return data.filter(d => guidList.indexOf(d.guid) >= 0);
            });
    }

    getViewModelsFromApi(map: { guid: string; objectType: number }[]): angular.IPromise<IValueViewModel[]> {
        return this.requestService.cachedPostAtV1('viewModel/list', map, undefined, true);
    }

    getViewModelsFromApiFromGuidList(guidList: string[]): angular.IPromise<IValueViewModel[]> {
        return this.requestService.cachedPostAtV1('viewModel/guidList', guidList, undefined, true);
    }

    cleanCompleteCache(): void {
        this.requestService.cleanCacheAtV1('viewModel/all');
    }

    cleanCache(data: string[]) {
        this.requestService.cleanCachedPostValue('viewModel/guidList', _.sortBy(data, d => d));
    }
}